export const organizationKeys = {
    all: ['organizations'] as const,
    lists: () => [...organizationKeys.all, 'list'] as const,
    list: () => [...organizationKeys.lists()] as const
};

export const billingKeys = {
    all: ['billing'] as const,
    products: () => [...billingKeys.all, 'products'] as const,
    organizations: () => [...billingKeys.all, 'organizations'] as const,
    organization: (organizationId: string) => [...billingKeys.organizations(), organizationId] as const,
    checkoutSessionMutation: (organizationId: string | null) =>
        [...billingKeys.all, 'checkout-session', organizationId] as const
};
